import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/index.styles'
import CombinationPicker from './CombinationPicker'
import VisibilitySensor from '../VisibilitySensor'
import { ColoriFormatiPageConfig } from '../configuration'
import useElementsVisible from '../app/hooks/useElementVisible'
import SlideUpHOC from '../SlideUpHOC'
import OnViewPortObserver from '../OnViewPortObserver'
import AssignId from '../AssignId'

const useStyles = makeStyles(styles)

function ColoriFormati() {
    const [state, setElemVisible] = useElementsVisible({
        h1: false,
        p: false
    })
    const classes = useStyles()
    return (
        <div className={classes.root}>
            <AssignId
                absolute
                y='-100px'
                yMobile='0'
                id='colori_e_formati'
            />
            <SlideUpHOC duration='0.8s' when={state.h1} >
                <h1 className={classes.h1} >{ColoriFormatiPageConfig.content.primary}</h1>
            </SlideUpHOC>
            <OnViewPortObserver
                absolute
                y={ColoriFormatiPageConfig.primaryTextOffset}
                yMobile={ColoriFormatiPageConfig.primaryTextOffsetMobile}
                onEnterViewPort={() => setElemVisible('h1')}
            />
            <SlideUpHOC duration='0.8s' when={state.p} >
                <p className={classes.p} >
                    {ColoriFormatiPageConfig.content.secondary[0]}
                    <strong className="strong">{ColoriFormatiPageConfig.content.secondary[1]}</strong>
                    {ColoriFormatiPageConfig.content.secondary[2]}
                    <strong className="strong">{ColoriFormatiPageConfig.content.secondary[3]}</strong>
                    {ColoriFormatiPageConfig.content.secondary[4]}
                </p>
            </SlideUpHOC>
            <VisibilitySensor index={3} />
            <OnViewPortObserver
                absolute
                y={ColoriFormatiPageConfig.subTextOffset}
                yMobile={ColoriFormatiPageConfig.subTextOffsetMobile}
                onEnterViewPort={() => setElemVisible('p')}
            />
            <CombinationPicker />
        </div>
    )
}

export default memo(ColoriFormati)